import React from "react";
import { Link } from "react-router-dom";
import { Layout } from "../../layouts/Layout";

import "./ConsultancyServices.css";
import whychooseus_consultancy from '../../assets/img/images/whychoose-consultancy-services.jpg'
import about_consultancy from '../../assets/img/images/about-consultancy-services.jpg'


const serviceItems = [
  {
    title: "Business Setup & Structuring",
    text: "Practical guidance for selecting the right business structure, establishing operations and creating a scalable foundation.",
  },
  {
    title: "Corporate & Regulatory Advisory",
    text: "Clear advice on corporate matters, regulatory requirements and compliance priorities relevant to your organisation.",
  },
  {
    title: "Risk Assessment & Compliance Health Check",
    text: "A structured review of legal, operational and compliance risks with practical recommendations for corrective action.",
  },
  {
    title: "Transaction & Negotiation Support",
    text: "Professional support for transaction planning, commercial documentation, negotiations and stakeholder coordination.",
  },
  {
    title: "Process Optimization",
    text: "Assessment and improvement of internal processes to increase efficiency, accountability and operational consistency.",
  },
  {
    title: "Business Strategy & Management Consulting",
    text: "Customized strategic advice for promoters, management teams, investors, startups, SMEs and growing enterprises.",
  },
];

const processSteps = [
  {
    number: "01",
    title: "Business Assessment",
    text: "We understand your business model, challenges, objectives, existing processes and immediate advisory requirements.",
  },
  {
    number: "02",
    title: "Strategic Planning",
    text: "Our consultants develop a practical roadmap aligned with your commercial goals, resources and risk profile.",
  },
  {
    number: "03",
    title: "Implementation Support",
    text: "We assist your team with documentation, coordination, process changes and execution of agreed recommendations.",
  },
  {
    number: "04",
    title: "Performance Review",
    text: "Outcomes are reviewed against agreed objectives so that gaps can be identified and improvements can be made.",
  },
  {
    number: "05",
    title: "Long-Term Advisory",
    text: "Ongoing strategic guidance helps your business respond to regulatory changes, risks and new growth opportunities.",
  },
];

const benefits = [
  "Better business decision-making",
  "Improved operational efficiency",
  "Stronger compliance framework",
  "Reduced legal and business risks",
  "Strategic growth planning",
  "Professional transaction support",
  "Practical process improvement",
  "Long-term business sustainability",
];

const faqs = [
  {
    question: "Who can benefit from Consultancy Services?",
    answer:
      "Startups, SMEs, corporates, promoters, investors, LLPs and management teams seeking strategic, legal, regulatory or operational guidance can benefit from our consultancy services.",
  },
  {
    question: "Do you provide compliance health checks and audits?",
    answer:
      "Yes. We review existing processes, records and compliance practices, identify gaps and provide a prioritized improvement plan.",
  },
  {
    question: "Can you assist with business restructuring?",
    answer:
      "Yes. We support eligible businesses with restructuring strategy, documentation, regulatory coordination and implementation planning.",
  },
  {
    question: "Do you provide customized advisory solutions?",
    answer:
      "Yes. Every assignment is tailored to the organisation's size, sector, challenges, objectives and regulatory environment.",
  },
];

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M20 6 9 17l-5-5"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M5 12h14M13 6l6 6-6 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ServiceIcon = ({ index }) => {
  const icons = [
    <path key="1" d="M4 21V7l8-4 8 4v14M8 10h2m4 0h2M8 14h2m4 0h2M9 21v-3h6v3" />,
    <path key="2" d="M12 3 4 6v5c0 5 3.4 8.4 8 10 4.6-1.6 8-5 8-10V6l-8-3Zm-3 9 2 2 4-4" />,
    <path key="3" d="M4 5h16v14H4V5Zm0 4h16M8 3v4m8-4v4M8 13h3m2 0h3m-8 3h3" />,
    <path key="4" d="M5 12h14M12 5l3 3-3 3M12 13l-3 3 3 3" />,
    <path key="5" d="M4 18V9m5 9V5m5 13v-7m5 7V3M3 21h18" />,
    <path key="6" d="M4 20h16M6 20V9m12 11V9M3 9h18L12 3 3 9Zm7 4h4m-4 3h4" />,
  ];

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {icons[index]}
      </g>
    </svg>
  );
};

const ConsultancyServices = () => {
  return (
    <Layout header={4} footer={2}  breadcrumb="Consultancy Services" title="Consultancy Services">
      <main className="consultancy-page">
        <section className="consultancy-intro section-space">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 col-md-10 mx-auto">
                <div className="consultancy-intro__visual">
                  <img
                    className="consultancy-intro__main-image"
                    src={about_consultancy}
                    alt="Business consultancy professionals"
                  />

                  <div className="consultancy-intro__experience-card">
                    <strong>360°</strong>
                    <span>Strategic business advisory and implementation support</span>
                  </div>

                
                </div>
              </div>

              <div className="col-lg-6">
                <div className="consultancy-section-heading">
                  <span className="consultancy-eyebrow">Strategic Business Advisory</span>
                  <h2>Practical Consultancy Solutions for Sustainable Business Growth</h2>
                </div>

                <p className="consultancy-lead">
                  In today&apos;s competitive business environment, organisations
                  require strategic guidance to improve efficiency, reduce risks and
                  achieve sustainable growth.
                </p>

                <p>
                  Globiz India combines legal expertise, corporate governance
                  knowledge and practical business experience to deliver customised
                  solutions for startups, SMEs, corporates, promoters, investors and
                  LLPs.
                </p>

                <div className="consultancy-highlight-list">
                  <div className="consultancy-highlight-item">
                    <span className="consultancy-highlight-item__icon">
                      <CheckIcon />
                    </span>
                    <div>
                      <h4>Customized Strategic Guidance</h4>
                      <p>Advice designed around your goals, challenges and business model.</p>
                    </div>
                  </div>

                  <div className="consultancy-highlight-item">
                    <span className="consultancy-highlight-item__icon">
                      <CheckIcon />
                    </span>
                    <div>
                      <h4>From Planning to Implementation</h4>
                      <p>Practical support that helps turn recommendations into measurable action.</p>
                    </div>
                  </div>
                </div>

                <div className="consultancy-intro__actions">
                  <Link to="/contact" className="consultancy-btn consultancy-btn--primary">
                    Discuss Your Business Needs <ArrowIcon />
                  </Link>

                
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="consultancy-speciality">
          <div className="container-fluid p-0">
            <div className="row g-0 align-items-stretch">
              <div className="col-lg-6 consultancy-speciality__content-col">
                <div className="consultancy-speciality__content">
                  <span className="consultancy-eyebrow consultancy-eyebrow--light">
                    What We Cover
                  </span>
                  <h2>Integrated Advisory for Better Business Decisions</h2>
                  <p>
                    We review your current position, identify opportunities and risks,
                    and provide practical recommendations that support efficiency,
                    compliance and long-term growth.
                  </p>

                  <div className="accordion consultancy-accordion" id="consultancyAccordion">
                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultancyOne"
                          aria-expanded="true"
                          aria-controls="consultancyOne"
                        >
                          Business Setup, Structuring and Corporate Advisory
                        </button>
                      </h3>
                      <div
                        id="consultancyOne"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#consultancyAccordion"
                      >
                        <div className="accordion-body">
                          We assist with entity structuring, business setup planning,
                          promoter advisory, governance frameworks and strategic corporate
                          decisions.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultancyTwo"
                          aria-expanded="false"
                          aria-controls="consultancyTwo"
                        >
                          Legal, Regulatory and Risk Advisory
                        </button>
                      </h3>
                      <div
                        id="consultancyTwo"
                        className="accordion-collapse collapse"
                        data-bs-parent="#consultancyAccordion"
                      >
                        <div className="accordion-body">
                          Compliance health checks, risk assessments, document reviews
                          and regulatory guidance help strengthen your business framework.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h3 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#consultancyThree"
                          aria-expanded="false"
                          aria-controls="consultancyThree"
                        >
                          Transactions, Processes and Growth Strategy
                        </button>
                      </h3>
                      <div
                        id="consultancyThree"
                        className="accordion-collapse collapse"
                        data-bs-parent="#consultancyAccordion"
                      >
                        <div className="accordion-body">
                          We support transactions, negotiations, process optimization,
                          performance improvement and long-term strategic planning.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 consultancy-speciality__image-col">
                <img
                  src={whychooseus_consultancy}
                  alt="Consultants discussing business strategy"
                />
                <div className="consultancy-speciality__image-overlay">
                  <span>Insight. Strategy. Execution.</span>
                  <strong>Advisory designed to create measurable business value.</strong>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="consultancy-services section-space">
          <div className="container">
            <div className="consultancy-section-heading consultancy-section-heading--center">
              <span className="consultancy-eyebrow">Our Consultancy Solutions</span>
              <h2>Professional Guidance Across Critical Business Areas</h2>
              <p>
                Flexible consulting support tailored to your organisation&apos;s stage,
                sector, priorities and operational requirements.
              </p>
            </div>

            <div className="row g-4">
              {serviceItems.map((item, index) => (
                <div className="col-lg-4 col-md-6" key={item.title}>
                  <article className="consultancy-service-card">
                    <div className="consultancy-service-card__icon">
                      <ServiceIcon index={index} />
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                    <Link to="/contact" className="consultancy-text-link">
                      Get expert guidance <ArrowIcon />
                    </Link>
                  </article>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="consultancy-benefits section-space">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-5">
                <div className="consultancy-section-heading">
                  <span className="consultancy-eyebrow">Why Choose Globiz India</span>
                  <h2>Legal Expertise Combined with Practical Business Experience</h2>
                </div>
                <p>
                  Our multidisciplinary approach gives decision-makers clear,
                  commercially practical and implementation-focused advice rather than
                  generic recommendations.
                </p>
                <Link to="/contact" className="consultancy-btn consultancy-btn--dark">
                  Speak with Our Consultants <ArrowIcon />
                </Link>
              </div>

              <div className="col-lg-7">
                <div className="consultancy-benefits__grid">
                  {benefits.map((benefit) => (
                    <div className="consultancy-benefit-item" key={benefit}>
                      <span>
                        <CheckIcon />
                      </span>
                      <p>{benefit}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="consultancy-process section-space">
          <div className="container">
            <div className="consultancy-section-heading consultancy-section-heading--center">
              <span className="consultancy-eyebrow">Consulting Process</span>
              <h2>A Structured Journey from Assessment to Long-Term Advisory</h2>
            </div>

            <div className="consultancy-process__track">
              {processSteps.map((step) => (
                <article className="consultancy-process-card" key={step.number}>
                  <span className="consultancy-process-card__number">{step.number}</span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="consultancy-faq section-space">
          <div className="container">
            <div className="row g-5 align-items-start">
              <div className="col-lg-5">
                <div className="consultancy-section-heading">
                  <span className="consultancy-eyebrow">Frequently Asked Questions</span>
                  <h2>Clear Answers About Our Consultancy Support</h2>
                </div>
                <p>
                  Every business challenge is different. Our team can assess your
                  requirements and recommend the right scope of advisory support.
                </p>
                <Link to="/contact" className="consultancy-btn consultancy-btn--primary">
                  Ask Our Consultants <ArrowIcon />
                </Link>
              </div>

              <div className="col-lg-7">
                <div className="accordion consultancy-faq__accordion" id="consultancyFaq">
                  {faqs.map((faq, index) => {
                    const collapseId = `consultancyFaq${index + 1}`;

                    return (
                      <div className="accordion-item" key={faq.question}>
                        <h3 className="accordion-header">
                          <button
                            className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={index === 0 ? "true" : "false"}
                            aria-controls={collapseId}
                          >
                            {faq.question}
                          </button>
                        </h3>
                        <div
                          id={collapseId}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                          data-bs-parent="#consultancyFaq"
                        >
                          <div className="accordion-body">{faq.answer}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="consultancy-cta">
          <div className="container">
            <div className="consultancy-cta__inner">
              <div>
                <span className="consultancy-eyebrow consultancy-eyebrow--light">
                  Plan Better. Execute Confidently.
                </span>
                <h2>Need practical guidance for your next business decision?</h2>
                <p>
                  Let Globiz India help you strengthen operations, reduce risks and
                  build a clear path toward sustainable growth.
                </p>
              </div>
              <Link to="/contact" className="consultancy-btn consultancy-btn--white">
                Request a Consultation <ArrowIcon />
              </Link>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default ConsultancyServices;
